import { scaleLinear, scaleTime } from 'd3-scale';
import { Group } from '@visx/group';
import { LinePath } from '@visx/shape';
import { formatSeriesData } from './Charts/MultiPredictionTimeSeriesChart/utils';
import { memo } from 'react';

const STROKE_WIDTH = 2;
const HALF_STROKE_WIDTH = STROKE_WIDTH / 2;

const Sparkline = memo(
    ({
        data,
        width,
        height,
        margin = {
            t: HALF_STROKE_WIDTH,
            b: HALF_STROKE_WIDTH,
            l: HALF_STROKE_WIDTH,
            r: HALF_STROKE_WIDTH,
        },
        strokeWidth = STROKE_WIDTH,
        strokeThemeColorAccessors = [
            ({ theme }) => theme.gray_4,
            ({ theme }) => theme.purple_1,
        ],
    }) => {
        const {
            accessors,
            xMin,
            xMax,
            yMin,
            yMax,
            formattedData: [{ historical, prediction }],
        } = formatSeriesData([{ timeSeries: data }]);
        const xScale = scaleTime()
            .domain([xMin, xMax])
            .range([margin.l, width - margin.l + margin.r]);
        const yScale = scaleLinear()
            .domain([yMin, yMax])
            .range([height - margin.b + margin.t, margin.t]);
        const x = (d) => xScale(new Date(accessors.xAccessor(d)));
        const y = (d) => yScale(accessors.yAccessor(d));
        const [historicalThemeColorAccessor, predictionThemeColorAccessor] =
            strokeThemeColorAccessors;

        return (
            <svg width={width} height={height}>
                <Group>
                    <LinePath
                        x={x}
                        y={y}
                        data={historical}
                        css={`
                            stroke: ${historicalThemeColorAccessor};
                            stroke-width: ${strokeWidth}px;
                            stroke-linejoin: round;
                        `}
                    />
                    <LinePath
                        x={x}
                        y={y}
                        data={prediction}
                        css={`
                            stroke: ${predictionThemeColorAccessor};
                            stroke-width: ${strokeWidth}px;
                            stroke-linejoin: round;
                        `}
                    />
                </Group>
            </svg>
        );
    },
);

export default Sparkline;
